<template>
    <div class="card st-framework-card">

        <div class="card-header">
            <table style="width: 100%;">
                <tbody>
                <tr>
                    <td style="margin: 0; padding: 0 0 0 7px; width: 40px;" v-if="environment === 'Local'">
                        <button type="button" class="btn btn-dark btn-sm" v-on:click="reloadPluginFiles(['drill_and_cutting_list/drill_and_cutting_list.rb'])">
                            <font-awesome-icon :icon="['fas','sync']"/>
                        </button>
                    </td>
                    <td style="margin: 0; padding: 0 0 0 7px; width: 40px;" v-else>
                        <button type="button" class="btn btn-dark btn-sm" v-on:click="reloadPage()">
                            <font-awesome-icon :icon="['fas','sync']"/>
                        </button>
                    </td>
                    <td style="margin: 0; padding: 0; width: 230px;">
                        {{ $i18n.tc('translations.' + name, 2).toUpperCase() }}
                    </td>
                    <template v-if="serverDataLoaded">
                        <td style="width: 1rem;"></td>
                        <template v-if="data.model.project">
                            <td style="padding: 0 10px; border: solid 1px lightgray; width: 30%;" v-if="data.model.phase">
                                {{ data.model.phase.label }}
                            </td>
                            <td style="width: 30%;" v-else/>
                            <td style="width: 1rem;"/>
                            <td style="padding: 0 10px; border: solid 1px lightgray;">
                                <LinkAction :action="actions.modelLinkAction"/>
                            </td>
                            <td style="padding: 0; width: 90px; text-align: right;">
                                (#{{ data.model.phase ? data.model.phase.id : (data.model.order ? data.model.order.id : data.model.project.id) }})
                            </td>
                        </template>
                        <template v-else>
                            <td style="padding: 0 10px; border: solid 1px lightgray;">
                                <router-link :to="{name: 'order_list'}" class="st-cardheader-link">
                                    {{ $i18n.t('translations.SketchUp model is not linked to a project') }}!
                                </router-link>
                            </td>
                        </template>
                        <td style="width: 1rem;"></td>
                    </template>
                    <td v-else/>
                </tr>
                </tbody>
            </table>
        </div>

        <template v-if="incompatibleSketchUpPlugin">
            <div class="card-body" style="text-align: center; font-size: larger; font-weight: bold; color: red;">
                <div>{{ $i18n.t("translations.incompatibleSketchUpPluginVersionForModule", {version: this.minimumSketchUpPluginVersion}) }}</div>
            </div>
        </template>
        <template v-else-if="serverDataLoaded">
            <div class="card-body p-0">

                <div class="card" style="border: none;">
                    <div class="card-header light p-0" style="border: none;">
                        <table style="width: 100%;">
                            <tbody>
                            <tr>
                                <td>
                                    <template v-for="(action,actionIndex) in actions.document">
                                        <template v-if="action.placement === 'DOCUMENTHEADERLEFT'">
                                            <ToggleAction :key="action.name+'-'+actionIndex"
                                                          :action="action" :disabled="state.disabled"
                                                          v-on:toggle-cutting-list="toggleCuttingList"
                                                          v-on:toggle-drill-list="toggleDrillList"
                                                          v-on:toggle-assembly-definition="toggleAssemblyDefinition"
                                                          v-on:toggle-assembly-definition-created="toggleAssemblyDefinition"
                                                          v-if="action.type === 'TOGGLE'"/>
                                        </template>
                                    </template>
                                </td>
                                <td>
                                    <div class="float-right">
                                        <template v-for="(action,actionIndex) in actions.document">
                                            <template v-if="action.placement === 'DOCUMENTHEADERRIGHT'">
                                                <ButtonAction :key="action.name+'-'+actionIndex"
                                                              :action="action"
                                                              :disabled="state.disabled || (action.name === 'generate-drill-files' && !drillListCount) || (action.name === 'generate-cutting-list' && !cuttingListCount)"
                                                              v-on:generate-drill-files="generateDrillFiles"
                                                              v-on:generate-cutting-list="generateCuttingList(action)"
                                                              v-if="action.type === 'BUTTON'"/>
                                            </template>
                                        </template>
                                    </div>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <Table :key="'component-table-'+tableReload" header-class="light" footer-class="light" body-class=""
                       with-filter with-pagination pagination-always-visible no-state-loading autofocus highlight-rows-on-click
                       :lines-per-page=data.crudLinesPerPage :rows="filteredComponentList"
                       :fields="fields.table" :actions="actions.table" :state="state"
                       v-on:clear-selection="clearSelection"
                       v-on:click-row="clickRow"
                       v-on:delete-selection="deleteSelection"
                       v-on:export-event="exportDrillAndCuttingList"
                       v-on:get-components="getDrillAndCuttingList"
                       v-on:select-all="selectAll"
                       v-on:select-component="selectComponent"/>

            </div>
        </template>

    </div>
</template>

<script>
import FileDownload from "@/mixins/FileDownload";
import LinkAction from "@/components/actions/LinkAction.vue";
import SketchUp from "@/mixins/SketchUp";
import Table from "@/components/Table";
import ButtonAction from "@/components/actions/ButtonAction.vue";
import ToggleAction from "@/components/actions/ToggleAction.vue";

/* global sketchup:false */

export default {
    name: 'DrillAndCuttingList',
    components: {
        ToggleAction, ButtonAction,
        LinkAction,
        Table,
    },
    props: ['name', 'icon', 'api', 'state', 'environment'],
    mixins: [FileDownload, SketchUp],
    data() {
        return {
            serverDataLoaded: false,
            tableReload: 0,
            sketchUpToolData: null,
            minimumSketchUpPluginVersion: '1.26.0',
            incompatibleSketchUpPlugin: false,
            showCuttingList: true,
            showDrillList: true,
            showAssemblyDefinition: false,
            productReferences: [],
            data: null,
            fields: null,
            actions: null,
            componentTag: '',
            clearComponents: true,
            rawComponentList: [],
            processedComponentList: [],
            filteredComponentList: [],
            cuttingListCount: 0,
            drillListCount: 0,
        }
    },
    created() {
        window.vm.Tool = this;
        this.getToolData();
    },
    methods: {
        clearSelection() {
            sketchup.clearSelection();
        },
        clickRow(component) {
            if (component.entity_ids && component.entity_ids.length > 0) {
                sketchup.selectComponents(component.entity_ids, true);
            }
        },
        deleteSelection() {
            this.filteredComponentList.forEach(component => {
                if (component.selected) {
                    let i = this.processedComponentList.findIndex(item => item.id === component.id);
                    this.processedComponentList.splice(i, 1);
                }
            });
            this.filterComponentList();
        },
        exportDrillAndCuttingList(choice) {
            let noSelection = true;
            this.filteredComponentList.forEach(component => {
                if (component.selected) {
                    noSelection = false;
                }
            });
            let components = [];
            this.filteredComponentList.forEach(component => {
                if (noSelection || component.selected) {
                    components.push({
                        'tag': component.tag,
                        'assembly_definition': component.assembly_definition,
                        'definition': component.definition,
                        'product_name': component.product_name,
                        'attribute_naam': component.attribute_naam,
                        'attribute_profiel': component.attribute_profiel,
                        'attribute_staal': component.attribute_staal,
                        'quantity': component.quantity,
                        'attribute_hoeveelheid': component.attribute_hoeveelheid,
                        'attribute_eenheid': component.attribute_eenheid,
                        'attribute_breedte': component.attribute_breedte,
                        'attribute_hoogte': component.attribute_hoogte,
                        'drill_holes_count': component.drill_holes_count,
                        'file_name': component.file_name,
                    });
                }
            });
            this.$http.post(choice.api, {
                'components': components,
            }, {'responseType': 'blob'}).then((res) => {
                this.fileDownload(choice, res.data);
                this.state.loading = false;
            }).catch((error) => {
                console.log("exportDrillAndCuttingList:download():error:", error);
            });
        },
        fetchData() {
            this.state.loading = true;
            this.$http.get(this.api + '/manage_drill_and_cutting_list/' + this.sketchUpToolData.project_id + '/' + this.sketchUpToolData.order_id + '/' + this.sketchUpToolData.phase_id, {}).then((res) => {
                this.actions = res.data.actions;
                this.fields = res.data.fields;
                this.data = res.data.data;
                if (this.data?.products) {
                    this.productReferences = this.data.products.map(p => p.reference);
                }
                this.setTableFields();
                this.serverDataLoaded = true;
                this.state.loading = false;
            }).catch((error) => {
                console.log("DrillAndCuttingList:fetchData():error:", error);
            });
        },
        filterComponentList() {
            let id = 1;
            this.filteredComponentList = [];
            this.drillListCount = 0;
            this.cuttingListCount = 0;
            this.processedComponentList.forEach(component => {
                component.id = id++;
                component.selected = false;
                if (this.showDrillList && component.attribute_boorgaten || this.showCuttingList && !component.attribute_boorgaten) {
                    this.filteredComponentList.push(component);
                    this.cuttingListCount++;
                    if (component.attribute_boorgaten) {
                        this.drillListCount++;
                    }
                }
            });
            this.setTableFields();
            this.tableReload++;
        },
        generateCuttingList(action) {
            let noSelection = true;
            this.filteredComponentList.forEach(component => {
                if (component.selected) {
                    noSelection = false;
                }
            });
            let components = [];
            this.filteredComponentList.forEach(component => {
                if (noSelection || component.selected) {
                    components.push({
                        'definition': component.assembly_definition,
                        'product_name': component.product_name,
                        'quantity': component.quantity,
                        'attribute_hoeveelheid': component.attribute_hoeveelheid,
                        'attribute_eenheid': component.attribute_eenheid,
                        'drill_holes_count': component.drill_holes_count,
                    });
                }
            });
            this.state.loading = true;
            this.$http.post(action.api, {
                'components': components,
            }, {'responseType': 'blob'}).then((res) => {
                this.fileDownload(action, res.data);
                this.state.loading = false;
            }).catch((error) => {
                console.log("DrillAndCuttingList:generateCuttingList():error:", error);
            });
        },
        generateDrillFiles() {
            this.state.loading = true;
            let noSelection = true;
            this.filteredComponentList.forEach(component => {
                if (component.selected) {
                    noSelection = false;
                }
            });
            let components = [];
            this.filteredComponentList.forEach(component => {
                if ((noSelection || component.selected) && component.attribute_boorgaten) {
                    components.push(component);
                }
            });
            sketchup.generateDrillFiles({
                    drill_files_path: this.data.drillFilesPath,
                    order_label: this.data?.model?.order?.label ?? 'n/a',
                },
                components,
            );
        },
        generateDrillFilesCallback() {
            this.state.loading = false;
        },
        getDrillAndCuttingList(data) {
            this.state.loading = true;
            this.clearComponents = 'clear-components' in data && data['clear-components'] === "1";
            if ('component-tag' in data) {
                this.componentTag = data['component-tag'];
            } else {
                this.componentTag = '';
            }
            sketchup.getDrillAndCuttingList(this.productReferences);
        },
        getDrillAndCuttingListCallback(data) {
            this.rawComponentList = JSON.parse(data);
            this.processComponentList();
        },
        getToolData() {
            this.state.loading = true;
            sketchup.getToolData();
        },
        getToolDataCallback(data) {
            this.sketchUpToolData = data;
            if (this.isVersionGreaterOrEqual(this.sketchUpToolData.plugin_version, this.minimumSketchUpPluginVersion)) {
                this.fetchData();
            } else {
                this.incompatibleSketchUpPlugin = true;
                this.state.loading = false;
            }
        },
        processComponentList() {
            this.$worker.run((rawComponentList, processedComponentList, model, products, componentTag, assemblyDefinitions, showAssemblyDefinition) => {
                rawComponentList.forEach(component => {
                    if (component.attribute_boorgaten) {
                        component.drill_data.sort(function (a, b) {
                            if (a.x !== b.x) {
                                return parseFloat(a.x) - parseFloat(b.x);
                            }
                            if (a.y !== b.y) {
                                return parseFloat(a.y) - parseFloat(b.y);
                            }
                            if (a.z !== b.z) {
                                return parseFloat(a.z) - parseFloat(b.z);
                            }
                            if (a.z !== b.z) {
                                return parseFloat(a.z) - parseFloat(b.z);
                            }
                            return parseFloat(a.radius) - parseFloat(b.radius);
                        });
                    }
                });

                let componentList = processedComponentList;
                rawComponentList.forEach(component => {
                    var product = products.find(p => {
                        return p.reference === component.attribute_naam;
                    });
                    let assemblyDefinition = component.definition_path.find(function (definition) {
                        return assemblyDefinitions.some(d => d.name === definition.substring(0, definition.indexOf("#")));
                    });
                    assemblyDefinition = assemblyDefinition ? assemblyDefinition : '';
                    let match = false;
                    for (var i = 0; i < componentList.length; i++) {
                        if ((componentList[i].tag === componentTag) &&
                            (!showAssemblyDefinition || (componentList[i].assembly_definition === assemblyDefinition)) &&
                            (componentList[i].attribute_naam === component.attribute_naam) &&
                            (componentList[i].attribute_boorgaten === component.attribute_boorgaten) &&
                            (componentList[i].attribute_hoeveelheid === component.attribute_hoeveelheid)) {
                            if (componentList[i].attribute_boorgaten) {
                                match = true;
                                for (var j = 0; j < componentList[i].drill_data.length; j++) {
                                    if (componentList[i].drill_data[j].x !== component.drill_data[j].x) {
                                        match = false;
                                        break;
                                    }
                                }
                            } else {
                                match = true;
                            }
                            if (match) {
                                break;
                            }
                        }
                    }
                    if (match) {
                        if (componentList[i].entity_ids.indexOf(component.entity_id) === -1) {
                            componentList[i].entity_ids.push(component.entity_id);
                        }
                        componentList[i].quantity++;
                    } else {
                        componentList.push({
                            'entity_ids': [component.entity_id],
                            'selected': false,
                            'tag': componentTag,
                            'assembly_definition': showAssemblyDefinition ? assemblyDefinition : '',
                            'definition': component.definition,
                            'drill_piece': component.attribute_boorgaten ? component.definition : '',
                            'product_name': product?.product_name ?? component.attribute_naam,
                            'attribute_naam': component.attribute_naam,
                            'attribute_profiel': component.attribute_profiel,
                            'attribute_staal': component.attribute_staal,
                            'quantity': 1,
                            'attribute_hoeveelheid': component.attribute_hoeveelheid,
                            'attribute_eenheid': component.attribute_eenheid,
                            'attribute_breedte': component.attribute_breedte,
                            'attribute_hoogte': component.attribute_hoogte,
                            'attribute_boorgaten': component.attribute_boorgaten,
                            'drill_data': component.drill_data,
                            'drill_holes_count': component.attribute_boorgaten ? component.drill_data.length : '',
                        });
                        i = componentList.length - 1;
                    }
                });

                componentList.forEach(component => {
                    if (component.attribute_boorgaten) {
                        let name = component.assembly_definition;
                        let count = componentList.filter(c => c?.name?.startsWith(name)).length;
                        if (count) {
                            name += '_' + (count + 1);
                        }
                        component.name = name;
                        let fileName = (model?.project?.id ?? '')
                            + '__' + component.assembly_definition
                            + '__' + component.attribute_hoeveelheid + 'mm'
                            + '__' + component.quantity + '__st';
                        count = componentList.filter(c => c?.file_name?.startsWith(fileName)).length;
                        if (count) {
                            fileName += '__' + (count + 1);
                        }
                        component.file_name = fileName + '.nc1';
                    }
                });

                componentList.sort(function (a, b) {
                    if (a.tag < b.tag) return -1;
                    if (a.tag > b.tag) return 1;
                    if (showAssemblyDefinition) {
                        let idxA = a.assembly_definition.lastIndexOf('#');
                        let idxB = b.assembly_definition.lastIndexOf('#');
                        if (idxA > -1 &&
                            idxB > -1 &&
                            a.assembly_definition.substring(0, idxA) === b.assembly_definition.substring(0, idxB) &&
                            !isNaN(parseInt(a.assembly_definition.substring(idxA + 1))) &&
                            !isNaN(parseInt(b.assembly_definition.substring(idxB + 1)))) {
                            if (parseInt(a.assembly_definition.substring(idxA + 1)) < parseInt(b.assembly_definition.substring(idxB + 1))) return -1;
                            if (parseInt(a.assembly_definition.substring(idxA + 1)) > parseInt(b.assembly_definition.substring(idxB + 1))) return 1;
                        } else {
                            if (a.assembly_definition < b.assembly_definition) return -1;
                            if (a.assembly_definition > b.assembly_definition) return 1;
                        }
                    }
                    if (a.attribute_naam < b.attribute_naam) return -1;
                    if (a.attribute_naam > b.attribute_naam) return 1;
                    if (a.attribute_hoeveelheid < b.attribute_hoeveelheid) return -1;
                    if (a.attribute_hoeveelheid > b.attribute_hoeveelheid) return 1;
                    if (b.attribute_boorgaten) return -1;
                    if (a.attribute_boorgaten) return 1;
                    return 0;
                });

                return componentList;
            }, [this.rawComponentList, (this.clearComponents ? [] : this.processedComponentList), this.data.model, this.data.products, this.componentTag, (this.data.settings?.assembly?.definitions ?? []), this.showAssemblyDefinition]).then(data => {
                this.processedComponentList = data;
                this.filterComponentList();
                this.state.loading = false;
            }).catch(error => {
                console.log("DrillAndCuttingList:processComponentList():error:", error);
            });
        },
        selectAll(data) {
            let ids = [];
            this.filteredComponentList.forEach(component => {
                if (data.ids.includes(component.id)) {
                    ids = ids.concat(component.entity_ids);
                }
            });
            sketchup.selectComponents(ids);
        },
        selectComponent(component) {
            sketchup.selectComponents(component.entity_ids);
        },
        setTableFields() {
            let hasTags = false;
            this.filteredComponentList.forEach(component => {
                if (component.tag) {
                    hasTags = true;
                }
            });
            this.fields.table.forEach(field => {
                if (field.name === "tag") {
                    field.showintable = hasTags;
                } else if (field.name === "assembly_definition") {
                    field.showintable = this.showAssemblyDefinition;
                } else {
                    field.showintable = this.showDrillList || !field.showindrilllist;
                }
            });
        },
        toggleAssemblyDefinition(action) {
            this.state.loading = true;
            this.showAssemblyDefinition = action.toggled;
            this.processComponentList();
        },
        toggleCuttingList(action) {
            this.showCuttingList = action.toggled;
            this.filterComponentList();
        },
        toggleDrillList(action) {
            this.showDrillList = action.toggled;
            this.filterComponentList();
        },
    }
}
</script>

<style scoped>
</style>